import PropTypes from 'prop-types'
import React from 'react'
import { EmailPhoneApplicantField } from '../question_config_fields/EmailPhoneApplicantField'
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid'
import { EmailPhoneApplicantCitizenField } from '../question_fields/EmailPhoneApplicantCitizenField'
import Alert from '../../molecules/Alert'
import BoldLabelAndContent from '../../molecules/BoldLabelAndContent'

const Form = props => <EmailPhoneApplicantField baseName={props.baseName} />

const Template = props => (
  <div className="grid md:grid-cols-2 gap-4">
    <div>
      <EmailPhoneApplicantCitizenField payload={props.question.payload} name={props.name} disabled />
    </div>
    <Alert type="info" border>
      Se enviará un código de validación al correo o teléfono de la persona, el cual deberá ingresar antes de enviar sus
      respuestas.
    </Alert>
  </div>
)

const Answer = ({ answer }) => {
  return <BoldLabelAndContent label={answer.contact_medium_label} content={answer.value} el="li" />
}

const Response = ({ answer }) => {
  return (
    <BoldLabelAndContent label={`${answer.contact_medium_label}:`} content={answer.value} className="mb-2" el="li" />
  )
}

const EmailPhoneApplicantQuestion = {
  selectOption: {
    value: 'email_phone_applicant',
    label: 'Correo o teléfono de contacto',
    icon: <PhoneAndroidIcon fontSize="small" />
  },
  Form,
  Template,
  Answer,
  TaskResponse: Response,
  Response
}

export default EmailPhoneApplicantQuestion

Form.propTypes = {
  baseName: PropTypes.string
}

Template.propTypes = {
  name: PropTypes.string,
  question: PropTypes.object.isRequired
}

Answer.propTypes = {
  answer: PropTypes.object
}

Response.propTypes = {
  answer: PropTypes.object
}
